// src/extenders/usp-bar-marquee.js
var UspBarMarquee = class extends HTMLElement {
  /**
   * Creates an instance of UspBarMarquee.
   * Initializes state properties and binds event handlers.
   */
  constructor() {
    super();
    this.isInteracting = false;
    this.interactionTimeout = null;
    this.isMobile = false;
    this.handleTouchStart = this.pauseAnimation.bind(this);
    this.handleMouseDown = this.pauseAnimation.bind(this);
    this.handleScroll = this.pauseAnimation.bind(this);
    this.handleTouchEnd = this.resumeAnimation.bind(this);
    this.handleMouseUp = this.resumeAnimation.bind(this);
    this.handleMouseLeave = this.resumeAnimation.bind(this);
  }
  /**
   * Called when element is inserted into the DOM.
   * Initializes marquee functionality if on mobile and has row variant items.
   * 
   * @memberof UspBarMarquee
   */
  connectedCallback() {
    this.isMobile = window.innerWidth < 1024;
    const hasRowVariant = this.querySelector(".usp-bar__item--row");
    if (this.isMobile && hasRowVariant) {
      this.init();
    }
  }
  /**
   * Called when element is removed from the DOM.
   * Cleans up event listeners and pending timeouts to prevent memory leaks.
   * 
   * @memberof UspBarMarquee
   */
  disconnectedCallback() {
    this.removeEventListeners();
    if (this.interactionTimeout) {
      clearTimeout(this.interactionTimeout);
      this.interactionTimeout = null;
    }
  }
  /**
   * Initializes the marquee by attaching event listeners for user interactions.
   * Sets up touch, mouse, and scroll event handlers.
   * 
   * @private
   * @memberof UspBarMarquee
   */
  init() {
    this.addEventListener("touchstart", this.handleTouchStart);
    this.addEventListener("mousedown", this.handleMouseDown);
    this.addEventListener("scroll", this.handleScroll);
    this.addEventListener("touchend", this.handleTouchEnd);
    this.addEventListener("mouseup", this.handleMouseUp);
    this.addEventListener("mouseleave", this.handleMouseLeave);
  }
  /**
   * Removes all event listeners from the element.
   * Used for cleanup when element is disconnected from DOM.
   * 
   * @private
   * @memberof UspBarMarquee
   */
  removeEventListeners() {
    this.removeEventListener("touchstart", this.handleTouchStart);
    this.removeEventListener("mousedown", this.handleMouseDown);
    this.removeEventListener("scroll", this.handleScroll);
    this.removeEventListener("touchend", this.handleTouchEnd);
    this.removeEventListener("mouseup", this.handleMouseUp);
    this.removeEventListener("mouseleave", this.handleMouseLeave);
  }
  /**
   * Pauses the CSS marquee animation.
   * Called when user starts interacting (touch, mouse down, scroll).
   * Clears any pending resume timeout.
   * 
   * @memberof UspBarMarquee
   */
  pauseAnimation() {
    this.isInteracting = true;
    this.style.animationPlayState = "paused";
    if (this.interactionTimeout) {
      clearTimeout(this.interactionTimeout);
    }
  }
  /**
   * Resumes the CSS marquee animation after a 2-second delay.
   * Called when user stops interacting (touch end, mouse up, mouse leave).
   * Uses a timeout to prevent immediate resume during quick interactions.
   * 
   * @memberof UspBarMarquee
   */
  resumeAnimation() {
    if (this.interactionTimeout) {
      clearTimeout(this.interactionTimeout);
    }
    this.interactionTimeout = setTimeout(() => {
      this.isInteracting = false;
      this.style.animationPlayState = "running";
    }, 2e3);
  }
};
if (customElements.get("usp-bar-marquee") === void 0) {
  customElements.define("usp-bar-marquee", UspBarMarquee);
}
